/// \file customerView.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const CustomerViewList = lazy(() => import('../views/customer-view/list/view'));

async function customerViewDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/customer-view/list/loader')).default;
  return actualLoader(args);
}

export async function customerViewAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/customer-view/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="customer/:id"
    handle={{
      text: 'inherit'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <CustomerViewList />
        </Suspense>
      }     
      loader={customerViewDataLoader}
      action={customerViewAction}
      />
  </Route>
);

export default routes;